import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@shared/services/base.service';

@Injectable()
export class StoreGroupsService extends BaseService {
  public headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.storeGroups;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  downloadFileTemplate(): Observable<any> {
    const url = this.getFullUrl(this.envService.downloadFileTemplate);
    return this.http.get<any>(url, { headers: this.headers, responseType: 'blob' as 'json' });
  }

  validateImport(file): Observable<any> {
    const url = this.getFullUrl(this.envService.importValidate);
    const formData = new FormData();
    formData.append('file', file, file.name);

    this.headers.append('Content-Type', 'multipart/form-data');

    return this.http.post<any>(url, formData, {
      observe: 'body',
      headers: this.loaderHeaders()
    });
  }

  importSubmit(file): Observable<any> {
    const url = this.getFullUrl(this.envService.importSubmit);
    const formData = new FormData();
    formData.append('file', file, file.name);

    this.headers.append('Content-Type', 'multipart/form-data');

    return this.http.post<any>(url, formData, {
      headers: this.headers,
      observe: 'body'
    });
  }

  importLatest(): Observable<any> {
    const url = this.getFullUrl(this.envService.importLatest);

    return this.http.get<any>(url, {
      headers: this.headers,
      observe: 'body'
    });
  }
}
